import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, btnP, inpS } from "../../constants/styles";
import Fld from "../common/Fld";

function PaySettingsPage() {
  const { t, h, settings, setSettings, go, flash, plan } = useContext(Ctx); const hasWa = (plan.features || []).includes("whatsapp");
  const [waBot, setWaBot] = useState(settings.whatsapp_bot_enabled === "true");
  const [waReminder, setWaReminder] = useState(settings.wa_reminder_enabled === "true");
  const [reminderDay, setReminderDay] = useState(settings.wa_reminder_day || "1");
  const [overdueDays, setOverdueDays] = useState(settings.wa_reminder_overdue_days || "5");

  const toggleWaBot = () => {
    const newVal = !waBot;
    setWaBot(newVal);
    const strVal = newVal ? "true" : "false";
    setSettings(prev => ({ ...prev, whatsapp_bot_enabled: strVal }));
    api.saveSetting("whatsapp_bot_enabled", strVal);
    flash(newVal ? (t.whatsappBotEnabled || "WhatsApp Bot Enabled") : (t.whatsappBotDisabled || "WhatsApp Bot Disabled"));
  };

  // If no WhatsApp feature, redirect to settings
  if (!hasWa) {
    return <div style={{ paddingTop: 16 }}>
      <button onClick={() => go("settings")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
      <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.whatsappSettings || "WhatsApp Settings"}</h2>
      <div style={{ ...crd(h), textAlign: "center", padding: 32 }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>{"\uD83D\uDCAC"}</div>
        <div style={{ color: h.tx, fontSize: 14, fontWeight: 600, marginBottom: 6 }}>{t.whatsappPremium || "WhatsApp Features"}</div>
        <div style={{ color: h.ts, fontSize: 12 }}>{t.upgradeForWhatsapp || "Upgrade to Starter plan or above to enable WhatsApp Bot & Auto Reminders."}</div>
      </div>
    </div>;
  }

  return <div style={{ paddingTop: 16 }}>
    <button onClick={() => go("settings")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.whatsappSettings || "WhatsApp Settings"}</h2>

    {/* WhatsApp Auto-Reminders — Starter+ only */}
    {hasWa && <div data-coach="paysettings-upi" style={{ ...crd(h), padding: 20, marginTop: 16 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div>
          <h3 style={{ color: h.tx, fontSize: 14, fontWeight: 600, margin: 0 }}>{t.autoReminders || "Auto Rent Reminders"}</h3>
          <p style={{ color: h.sc, fontSize: 11, margin: "4px 0 0" }}>{t.autoRemindersDesc || "Automatically send rent reminders via WhatsApp"}</p>
        </div>
        <button onClick={() => {
          const newVal = !waReminder;
          setWaReminder(newVal);
          const strVal = newVal ? "true" : "false";
          setSettings(prev => ({ ...prev, wa_reminder_enabled: strVal }));
          api.saveSetting("wa_reminder_enabled", strVal);
          flash(newVal ? "Reminders Enabled" : "Reminders Disabled");
        }} style={{
          width: 48, height: 28, borderRadius: 14, border: "none", cursor: "pointer",
          background: waReminder ? h.gn : `${h.sc}40`, position: "relative", transition: "background 0.2s"
        }}>
          <div style={{
            width: 22, height: 22, borderRadius: 11, background: "#fff",
            position: "absolute", top: 3, left: waReminder ? 23 : 3, transition: "left 0.2s",
            boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
          }} />
        </button>
      </div>

      {waReminder && <div style={{ background: `${h.gn}08`, borderRadius: 10, padding: 12, marginTop: 8 }}>
        <div style={{ display: "flex", gap: 12, marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <label style={{ color: h.sc, fontSize: 11, display: "block", marginBottom: 4 }}>{t.reminderDay || "Reminder Day"}</label>
            <select value={reminderDay} onChange={e => {
              setReminderDay(e.target.value);
              setSettings(prev => ({ ...prev, wa_reminder_day: e.target.value }));
              api.saveSetting("wa_reminder_day", e.target.value);
            }} style={{ ...inpS(h), marginBottom: 0, fontSize: 13 }}>
              {Array.from({ length: 28 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}{i === 0 ? "st" : i === 1 ? "nd" : i === 2 ? "rd" : "th"} of month</option>)}
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ color: h.sc, fontSize: 11, display: "block", marginBottom: 4 }}>{t.overdueDays || "Overdue After"}</label>
            <select value={overdueDays} onChange={e => {
              setOverdueDays(e.target.value);
              setSettings(prev => ({ ...prev, wa_reminder_overdue_days: e.target.value }));
              api.saveSetting("wa_reminder_overdue_days", e.target.value);
            }} style={{ ...inpS(h), marginBottom: 0, fontSize: 13 }}>
              {[3, 5, 7, 10, 15].map(d => <option key={d} value={d}>{d} days</option>)}
            </select>
          </div>
        </div>
        <div style={{ color: h.gn, fontSize: 10, fontWeight: 500 }}>
          {"\u2713"} First reminder on {reminderDay}{reminderDay === "1" ? "st" : reminderDay === "2" ? "nd" : reminderDay === "3" ? "rd" : "th"} of each month
          {"\u00B7"} Overdue alerts after {overdueDays} days
          {"\u00B7"} Max 5 reminders per payment
        </div>
      </div>}
    </div>}

    {/* Phase 13: WhatsApp Bot Section — Starter+ only */}
    {hasWa && <div data-coach="paysettings-razorpay" style={{ ...crd(h), padding: 20, marginTop: 16 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div>
          <h3 style={{ color: h.tx, fontSize: 14, fontWeight: 600, margin: 0 }}>{t.whatsappBot || "WhatsApp Bot"}</h3>
          <p style={{ color: h.sc, fontSize: 11, margin: "4px 0 0" }}>{t.whatsappBotDesc || "Let tenants check info via WhatsApp"}</p>
        </div>
        <button onClick={toggleWaBot} style={{
          width: 48, height: 28, borderRadius: 14, border: "none", cursor: "pointer",
          background: waBot ? h.gn : `${h.sc}40`, position: "relative", transition: "background 0.2s"
        }}>
          <div style={{
            width: 22, height: 22, borderRadius: 11, background: "#fff",
            position: "absolute", top: 3, left: waBot ? 23 : 3, transition: "left 0.2s",
            boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
          }} />
        </button>
      </div>

      <div style={{ background: `${h.ac}10`, borderRadius: 10, padding: 12 }}>
        <p style={{ color: h.ac, fontSize: 12, fontWeight: 600, margin: "0 0 8px" }}>{t.sampleCommands || "Sample Commands"}</p>
        {[
          { cmd: "rent due", desc: t.rentDueCmd || "Check pending rent" },
          { cmd: "last payment", desc: t.lastPayCmd || "View last payment" },
          { cmd: "lease info", desc: t.leaseCmd || "Lease details" },
          { cmd: "maintenance", desc: t.maintCmd || "Request status" },
          { cmd: "help", desc: "Menu" }
        ].map((item, idx) => (
          <div key={idx} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <code style={{ background: `${h.ac}20`, color: h.ac, padding: "2px 8px", borderRadius: 6, fontSize: 11, fontWeight: 600, whiteSpace: "nowrap" }}>{item.cmd}</code>
            <span style={{ color: h.sc, fontSize: 11 }}>{item.desc}</span>
          </div>
        ))}
      </div>
    </div>}
  </div>;
}

export default PaySettingsPage;
